export default {
    items: [],
    page: 1,
    loading: false,
}